import * as React from 'react';
import {createView, view} from '@sail/engine';
import {visuallyHidden} from '../../utilStyles/visuallyHidden';
import type {View} from '../../view';

export const FocusGuard = createView((props: View.IntrinsicElement<'span'>) => {
  return <view.span hidden tabIndex={0} uses={[visuallyHidden]} {...props} />;
});
